const initialState = {
  newUser: false,
};

export default initialState;
